import LoadingComponent from '../components/loading/progressLinear';
import ErrorComponent from '../components/error/default';

export default ({
                  component,
                  loading = LoadingComponent,
                  error = ErrorComponent,
                  delay = 300,
                  timeout = 3000,
                }) => () => ({
  component: import(`../${component}`),
  loading,
  error,
  delay,
  timeout,
});
